import { useConfirmationModal } from '@common/confirmation.hooks';
import { useMemo } from 'react';
import { ELoadingRemovalCertConfirmationActionType } from './permitToLoadRemoveDetailPage.constants';

export const usePermitToLoadRemoveConfirmationModal = ({
  confirmationActionType,
  onConfirm,
}: {
  confirmationActionType: ELoadingRemovalCertConfirmationActionType | undefined;
  onConfirm: () => void;
}) => {
  const content = useMemo(() => {
    switch (confirmationActionType) {
      case ELoadingRemovalCertConfirmationActionType.createRevision:
        return 'Confirm to create revision?';
      case ELoadingRemovalCertConfirmationActionType.createRemovalCert:
        return 'Confirm to create removal cert?';
      case ELoadingRemovalCertConfirmationActionType.srpIssue:
        return 'Confirm to issue?';
      case ELoadingRemovalCertConfirmationActionType.twcApprove:
      case ELoadingRemovalCertConfirmationActionType.iceApprove:
        return 'Confirm to Approve?';
      case ELoadingRemovalCertConfirmationActionType.requestIceCert:
        return 'Confirm to request ICE cert?';
      case ELoadingRemovalCertConfirmationActionType.withdrawIceCert:
        return 'Confirm to withdraw ICE cert?';
      case ELoadingRemovalCertConfirmationActionType.delete:
        return 'Confirm to Cancel?';
      case ELoadingRemovalCertConfirmationActionType.removeRemovalCert:
        return 'Confirm to remove removal cert?';
      default:
        return '';
    }
  }, [confirmationActionType]);

  const { renderModal, openPortal } = useConfirmationModal({
    content,
    onConfirm,
  });

  return { renderModal, openPortal };
};
